import { ExportEntity, ExportType, LegacyExportType } from 'common/export/types';
import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type GeneralSettings =
  | 'PAGE_VIEW'
  | 'APP_HEADER_SEARCH_OPEN'
  | 'APP_HEADER_SEARCH_CLOSE'
  | 'APP_HEADER_SEARCH_RECENTLY_VIEWED_CLICK'
  | 'APP_HEADER_SEARCH_RESULT_CLICK'
  | 'APP_HEADER_SEARCH_OPEN_HUB_SEARCH'
  | 'APP_HEADER_SEARCH_OPEN_PAGE_SEARCH'
  | 'EXPORT'
  | 'HORIZONTAL_MENU_TAB_CLICK'
  | 'MAIN_MENU_CLICK'
  | 'SETTINGS_SUB_MENU_CLICK'
  | 'MY_ACCOUNT_SUB_MENU_CLICK'
  | 'APP_HEADER_AVATAR_BUTTON_CLICK'
  | 'APP_HEADER_AVATAR_MENU_ITEM_CLICK'
  | 'APP_HEADER_TASKS_CLICK'
  | 'APP_HEADER_TASKS_LOADED'
  | 'MAIN_MENU_EXPAND'
  | 'SIDE_PANEL_DRAWER_CLOSE_CLICK'
  | 'SIDE_PANEL_DRAWER_TAB_CLICK'
  | 'SIDE_PANEL_DRAWER_VIEW_MORE_CLICK'
  | 'SIDE_PANEL_DRAWER_EXPAND_COLLAPSE_ALL_CLICK'
  | 'SIDE_PANEL_DRAWER_OPEN_EDIT_DIALOG'
  | 'EXTERNAL_LINK_CLICK'
  | 'APP_TOP_BAR_BUTTON'
  | 'ACCORDION_EXPAND_COLLAPSE_CLICK';

export const general: Record<GeneralSettings, MixpanelEvent> = {
  PAGE_VIEW: {
    eventDescription: 'Page View',
    eventKey: 'page-view',
    eventSource: EventSource.PAGE_VIEW,
    interactionType: InteractionType.PAGE_VIEW
  },
  MAIN_MENU_EXPAND: {
    eventDescription: 'Main Menu Expand',
    eventKey: 'main-menu-expand',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.EXPAND_BUTTON
  },
  EXPORT: {
    eventDescription: 'Export',
    eventKey: 'export',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.OVERFLOW_MENU_ITEM_BUTTON
  },
  APP_HEADER_SEARCH_OPEN: {
    eventDescription: 'App Bar Search Open',
    eventKey: 'app-header-search-open',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SEARCH_INPUT
  },
  APP_HEADER_SEARCH_RECENTLY_VIEWED_CLICK: {
    eventDescription: 'App Bar Search Recently Viewed Click',
    eventKey: 'app-header-search-recently-viewed-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SEARCH_INPUT
  },
  APP_HEADER_SEARCH_RESULT_CLICK: {
    eventDescription: 'App Bar Search Result Click',
    eventKey: 'app-header-search-result-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SEARCH_INPUT
  },
  APP_HEADER_SEARCH_OPEN_HUB_SEARCH: {
    eventDescription: 'App Header Search Open Hub Search',
    eventKey: 'app-header-search-open-hub-search',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SEARCH_INPUT
  },
  APP_HEADER_SEARCH_OPEN_PAGE_SEARCH: {
    eventDescription: 'App Header Search Open Page Search',
    eventKey: 'app-header-search-open-page-search',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SEARCH_INPUT
  },
  APP_HEADER_SEARCH_CLOSE: {
    eventDescription: 'App Header Search Close',
    eventKey: 'app-header-search-close',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SEARCH_INPUT
  },
  MAIN_MENU_CLICK: {
    eventDescription: 'Main Menu Click',
    eventKey: 'main-menu-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.MAIN_MENU_BUTTON
  },
  HORIZONTAL_MENU_TAB_CLICK: {
    eventDescription: 'Horizontal Menu Tab Click',
    eventKey: 'horizontal_menu_tab_click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.HORIZONTAL_MENU_TAB
  },
  SETTINGS_SUB_MENU_CLICK: {
    eventDescription: 'Settings Sub Menu Click',
    eventKey: 'settings-sub-menu-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SUB_MENU_BUTTON
  },
  MY_ACCOUNT_SUB_MENU_CLICK: {
    eventDescription: 'My Account Sub Menu Click',
    eventKey: 'my-account-sub-menu-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SUB_MENU_BUTTON
  },
  APP_HEADER_AVATAR_BUTTON_CLICK: {
    eventDescription: 'App Header Avatar Button Click',
    eventKey: 'app-header-avatar-button-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.APP_BAR_AVATAR_BUTTON
  },
  APP_HEADER_AVATAR_MENU_ITEM_CLICK: {
    eventDescription: 'App Header Avatar Menu Item Click',
    eventKey: 'app-header-avatar-menu-item-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.APP_BAR_AVATAR_MENU_ITEM
  },
  APP_HEADER_TASKS_CLICK: {
    eventDescription: 'App Header Tasks Click',
    eventKey: 'app-header-tasks-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.TASKS_ITEM
  },
  APP_HEADER_TASKS_LOADED: {
    eventDescription: 'App Header Tasks Loaded',
    eventKey: 'app-header-tasks-loaded',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  SIDE_PANEL_DRAWER_CLOSE_CLICK: {
    eventDescription: 'Side Panel Drawer Close Click',
    eventKey: 'side-panel-drawer-close-click',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.CLOSE_BUTTON
  },
  SIDE_PANEL_DRAWER_TAB_CLICK: {
    eventDescription: 'Side Panel Drawer Tab Click',
    eventKey: 'side-panel-drawer-tab-click',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.TAB
  },
  SIDE_PANEL_DRAWER_VIEW_MORE_CLICK: {
    eventDescription: 'Side Panel Drawer View More Details Click',
    eventKey: 'side-panel-drawer-view-more-details-click',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.EXPAND_BUTTON
  },
  SIDE_PANEL_DRAWER_OPEN_EDIT_DIALOG: {
    eventDescription: 'Side Panel Drawer Open Edit Dialog',
    eventKey: 'side-panel-drawer-open-edit-dialog',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.EDIT_BUTTON
  },
  SIDE_PANEL_DRAWER_EXPAND_COLLAPSE_ALL_CLICK: {
    eventDescription: 'Side Panel Drawer Expand Collapse All Click',
    eventKey: 'side-panel-drawer-expand-collapse-all-click',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.EXPAND_COLLAPSE_ALL_BUTTON
  },
  ACCORDION_EXPAND_COLLAPSE_CLICK: {
    eventDescription: 'Accordion Expand/Collapse Click',
    eventKey: 'accordion-expand-collapse-click',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.ACCORDION_EXPAND_COLLAPSE_BUTTON
  },
  EXTERNAL_LINK_CLICK: {
    eventDescription: 'External Link Click',
    eventKey: 'external_link_click',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.EXTERNAL_LINK_BUTTON
  },
  APP_TOP_BAR_BUTTON: {
    eventDescription: 'App Top Bar Button Click',
    eventKey: 'app_top_bar_button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.APP_TOOLBAR_BUTTON
  }
} as const;

export type ExportOrigin =
  | 'table-tool-bar'
  | 'table-bulk-action'
  | 'quick-report-panel'
  | 'quick-report-drawer'
  | 'unknown';

export type TopBarButtonType = 'help';

export type AppTopBarButtonDetails = {
  origin: TopBarButtonType;
};

export type ExportEventDetails = {
  exportType: ExportType | LegacyExportType;
  exportEntity: ExportEntity;
  origin: ExportOrigin;
};

export type MainMenuExpandDetails = {
  isExpanded: boolean;
  eventSource?: EventSource;
  interactionType?: InteractionType;
};

export type SidePanelDrawerTabDetails<T> = {
  tabLabel: T;
};

export type SidePanelDrawerViewMoreDetails = {
  toggleAction: 'open' | 'close';
};

export type SidePanelDrawerExpandCollapseAllDetails = {
  toggleAction: 'Expand All' | 'Collapse All';
};

export type ExternalLinkDetails = {
  label: string;
  url: string;
  customClientLink?: boolean;
};
